(function (app) {

    app.provider("marketingTrackerUserFileApi",
        [
            function () {
                this.$get = [
                    "marketingTrackerApiGateway", function (marketingTrackerApiGateway) {
                        var service = {};

                        service.getFiles = function () {
                            return marketingTrackerApiGateway.getArray("/UserFiles");
                        };

                        service.downloadFile = function (userFileId) {
                            return marketingTrackerApiGateway.getFile("/UserFiles/" + userFileId);
                        };

                        service.getFileInfo = function (userFileId) {
                            return marketingTrackerApiGateway.get("/UserFiles/" + userFileId + "/Info");
                        };

                        service.updateFileName = function (userFileId, userFileInfo) {
                            return marketingTrackerApiGateway.put("/UserFiles/" + userFileId + "/FileName", userFileInfo);
                        };

                        service.deleteFile = function (userFileId) {
                            return marketingTrackerApiGateway.delete("/UserFiles/" + userFileId);
                        };

                        service.uploadUserFile = function (userFile, config) {
                            return marketingTrackerApiGateway.postFile("/UserFiles", userFile, config);
                        };

                        return service;
                    }
                ];
            }
        ]);
})(window.app); //jshint ignore:line